import { render, staticRenderFns } from "./AccountMarket.vue?vue&type=template&id=386e84ee&"
import script from "./AccountMarket.vue?vue&type=script&lang=ts&"
export * from "./AccountMarket.vue?vue&type=script&lang=ts&"
import style0 from "./AccountMarket.vue?vue&type=style&index=0&id=386e84ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports